import { render } from "./TiptapEditor.vue?vue&type=template&id=2e1a295a&scoped=true"
import script from "./TiptapEditor.vue?vue&type=script&lang=js"
export * from "./TiptapEditor.vue?vue&type=script&lang=js"

import "./TiptapEditor.vue?vue&type=style&index=0&id=2e1a295a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e1a295a"]])

export default __exports__